import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib/helpers/api';
import UserService from '@iso/services/AccountService/UserService';
import { types, actions } from './reducer';

function* deleteUser({ id }) {
    try {
        yield call(UserService.deleteOne, id);
        yield put(actions.deleteUserSucceeded(id));
    } catch (error) {
        yield put(actions.deleteUserFailed(extractError(error)));
    }
}

function* watchDeleteUser() {
    yield takeEvery(
        types.REQUEST_DELETE_USER,
        deleteUser,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteUser),
    ]);
}

export default deleteSaga;
